import React, { PropTypes } from 'react';
import axios from './../../../constants/axios';
import { Table, Button } from 'react-bootstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class JournalEntryHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         journalEntries: [],
         startDate: null,
         endDate: null,
      };
   }

   componentDidMount() {
      axios.get('accounting/journalEntries')
         .then((res) => {
            this.setState({
               journalEntries: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getJournalEntriesDateBetween = () => {
      const { startDate, endDate } = this.state;
      if (startDate && endDate) {
         axios.get('accounting/journalEntries', {
            params: {
               startDate: startDate.format('YYYY-MM-DD'),
               endDate: endDate.format('YYYY-MM-DD'),
            }
         })
            .then((res) => {
               this.setState({
                  journalEntries: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   render() {
      const { journalEntries } = this.state;
      return (
         <div className="JournalEntryHome" >
            <div>
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.startDate}
                  placeholderText="Select Start Date"
                  onChange={this.handleStartDateChange} />
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.endDate}
                  placeholderText="Select End Date"
                  onChange={this.handleEndDateChange} />
               <Button onClick={() => this.getJournalEntriesDateBetween()} >Get Journal Entries</Button>
            </div>
            <Table striped bordered condensed hover >
               <thead>
               <tr>
                  <th>Event Time</th>
                  <th>Particulars</th>
                  <th>Debit</th>
                  <th>Credit</th>
               </tr>

               </thead>
               <tbody>
               {journalEntries.map((entry) => (
                  <tr key={entry.id} >
                     <td className="col-md-2" >{moment(entry.event_time).format('YYYY-MM-DD')}</td>
                     <td>{entry.chart_of_account_name}</td>
                     <td>
                        {entry.amount > 0 ? entry.amount : null}
                     </td>
                     <td>
                        {entry.amount < 0 ? entry.amount : null}
                     </td>
                  </tr>
               ))}
               </tbody>
            </Table>
         </div>
      );
   }
}

JournalEntryHome.propTypes = {
   children: PropTypes.object
};

export default JournalEntryHome;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/JournalEntries/JournalEntryHome.js
 **/